import { Injectable, signal, Type } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SettingDialogType } from '@/models/dialog-mode.model';
import { BinderPrintSettingsComponent } from '@/landmark/binder/doc-viewer/doc-settings/binder-settings/binder.print-settings.component';
import { OwnerItemsSettingsComponent } from '@/landmark/binder/doc-viewer/doc-settings/owner-items-settings/owner-items-settings.component';
import { NewClientSettingsComponent } from '@/landmark/binder/doc-viewer/doc-settings/new-client-settings/new-client-settings.component';
import { MapSettingsComponent } from '@/landmark/binder/doc-viewer/doc-settings/map-settings/map-settings.component';


interface DialogConfig {
  header: string;
  width: string;
  height: string;
  position: string;
  closable: boolean;
  modal: boolean;
  contentStyle: {
    overflowY: string;
    top: string;
    bottom: string;
  };
  data: {
    editAccess: boolean;
  };
  baseZIndex: number;
  maximizable?: boolean;
  breakpoints?: {
    [key: string]: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class SettingsDialogService {
  private dialogMode =signal<SettingDialogType>(new SettingDialogType('Drafting Details', false, 1));

  dialogRef: DynamicDialogRef | undefined;
  isDialogOpen = signal<boolean>(false);

  constructor(public dialogService: DialogService) {
  }

  setDialogMode(mode: SettingDialogType) {
    this.dialogMode.set(mode);
  }

  toggleDialog(header: string, type: number, show: boolean, position?: string, noWidth?: boolean) {
    const mode = {
      header: header,
      modal: true,
      show: show || false,
      type: type,
      position: position || 'center'
    };
    this.dialogMode.set(mode);

    let component: Type<any>;
    let overflowY = 'hidden';

    let dialogConfig: DialogConfig = {
      header: header,
      modal: true,
      width: 'auto',
      height: 'auto',
      position: position || 'center',
      closable: true,
      contentStyle: {
        overflowY: overflowY,
        top: '5px',
        bottom: '5px'
      },
      breakpoints: {
        '1920px': '70vw',
        '1600px': '80vw',
        '1200px': '90vw',
        '960px': '100vw'
      },
      data: {
        editAccess: false
      },
      baseZIndex: 10000
    }

    switch (type) {
      case 5:
        component = OwnerItemsSettingsComponent;
        break;

      case 4:
        component = NewClientSettingsComponent;
        break;
      case 1:
        component = BinderPrintSettingsComponent;
        break;

        case 6:
          component = MapSettingsComponent;
          break;

      default:
        component = OwnerItemsSettingsComponent
        break;
    }

    console.log('dialog data', dialogConfig);
    if (show) {
      this.dialogRef = this.dialogService.open(component, dialogConfig);

      this.isDialogOpen.set(true);
      this.dialogRef.onClose.subscribe(() => {
        this.isDialogOpen.set(false);
      });
    } else {
      this.closeDialog();
    }
  }

  closeDialog(closeall?: boolean) {
    this.dialogRef?.close();
    // this.isDialogOpen.next(false);
  }
}